import { JOB_TYPE } from './const/job'
import { QUOTE_STATUS } from './const/quote'
import { TICKET_STATUS } from './const/ticket'

export const gradientBgBase = 'bg-gradient-to-tr'
export const gradientBgPurplePink = `${gradientBgBase} from-purple-400 via-pink-500 to-red-500`
export const gradientBgDark = `${gradientBgBase} from-slate-700 via-slate-900 to-slate-800`
export const gradientBgPinkRed = `${gradientBgBase} from-pink-400 via-red-500 to-yellow-500`

export const colorsBgLight = {
  white: 'bg-white text-black',
  light: 'bg-white text-black dark:bg-slate-900/70 dark:text-white',
  whiteDark: 'bg-gray-100 dark:bg-slate-800',
  lightDark: 'bg-gray-200 dark:bg-slate-700',
  contrast: 'bg-gray-800 text-white dark:bg-white dark:text-black',
  success: 'bg-emerald-500 border-emerald-500 text-white',
  danger: 'bg-red-500 border-red-500 text-white',
  warning: 'bg-yellow-500 border-yellow-500 text-white',
  info: 'bg-blue-500 border-blue-500 text-white',
  transparent: 'bg-transparent',
}

export const colorsText = {
  white: 'text-black dark:text-slate-100',
  light: 'text-gray-700 dark:text-slate-400',
  contrast: 'dark:text-white',
  success: 'text-emerald-500',
  danger: 'text-red-500',
  warning: 'text-yellow-500',
  info: 'text-peppermint',
}

export const colorsOutline = {
  white: [colorsText.white, 'border-gray-100'],
  light: [colorsText.light, 'border-gray-100'],
  contrast: [colorsText.contrast, 'border-gray-900 dark:border-slate-100'],
  success: [colorsText.success, 'border-emerald-500'],
  danger: [colorsText.danger, 'border-red-500'],
  warning: [colorsText.warning, 'border-yellow-500'],
  info: [colorsText.info, 'border-peppermint'],
}

export const borderColors = {
  white: 'border-white',
  whiteDark: 'border-white dark:border-slate-900',
  lightDark: 'border-gray-100 dark:border-slate-800',
  contrast: 'border-gray-800 dark:border-white',
  success: 'border-emerald-600 dark:border-emerald-500',
  danger: 'border-red-600 dark:border-red-500',
  warning: 'border-yellow-600 dark:border-yellow-500',
  info: 'border-peppermint dark:border-peppermint',
  transparent: 'transparent',
}

export const getButtonColor = (
  color,
  isOutlined,
  hasHover,
  isActive = false,
) => {
  const colors = {
    ring: {
      white: 'ring-gray-200 dark:ring-gray-500',
      whiteDark: 'ring-gray-200 dark:ring-gray-500',
      lightDark: 'ring-gray-200 dark:ring-gray-500',
      contrast: 'ring-gray-300 dark:ring-gray-400',
      success: 'ring-emerald-300 dark:ring-emerald-700',
      danger: 'ring-red-300 dark:ring-red-700',
      warning: 'ring-yellow-300 dark:ring-yellow-700',
      info: 'ring-peppermint dark:ring-peppermint',
      transparent: 'transparent',
    },
    active: {
      white: 'bg-gray-100',
      whiteDark: 'bg-gray-100 dark:bg-slate-800',
      lightDark: 'bg-gray-200 dark:bg-slate-700',
      contrast: 'bg-gray-700 dark:bg-slate-100',
      success: 'bg-emerald-700 dark:bg-emerald-600',
      danger: 'bg-red-700 dark:bg-red-600',
      warning: 'bg-yellow-700 dark:bg-yellow-600',
      info: 'bg-peppermint dark:bg-peppermint',
      transparent: 'transparent',
    },
    bg: {
      white: 'bg-white text-black',
      whiteDark: 'bg-white text-black dark:bg-slate-900 dark:text-white',
      lightDark: 'bg-gray-100 text-black dark:bg-slate-800 dark:text-white',
      contrast: 'bg-gray-800 text-white dark:bg-white dark:text-black',
      success: 'bg-emerald-600 dark:bg-emerald-500 text-white dark:text-black',
      danger: 'bg-red-600 dark:bg-red-500 text-white',
      warning: 'bg-yellow-500 text-black',
      info: 'bg-peppermint dark:bg-peppermint text-black',
      transparent: 'transparent',
    },
    bgHover: {
      white: 'hover:bg-gray-100',
      whiteDark: 'hover:bg-gray-100 hover:dark:bg-slate-800',
      lightDark: 'hover:bg-gray-200 hover:dark:bg-slate-700',
      contrast: 'hover:bg-gray-700 hover:dark:bg-slate-100',
      success:
        'hover:bg-emerald-700 hover:border-emerald-700 hover:dark:bg-emerald-600 hover:dark:border-emerald-600',
      danger:
        'hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600',
      warning:
        'hover:bg-yellow-700 hover:border-yellow-700 hover:dark:bg-yellow-600 hover:dark:border-yellow-600',
      info: 'hover:bg-peppermint hover:border-peppermint hover:dark:bg-peppermint hover:dark:border-peppermint',
      transparent: 'transparent',
    },
    borders: borderColors,
    text: {
      contrast: 'dark:text-slate-100',
      success: 'text-emerald-600 dark:text-emerald-500',
      danger: 'text-red-600 dark:text-red-500',
      warning: 'text-yellow-600 dark:text-yellow-500',
      info: 'text-peppermint dark:text-peppermint',
      transparent: 'transparent',
    },
    outlineHover: {
      contrast:
        'hover:bg-gray-800 hover:text-gray-100 hover:dark:bg-slate-100 hover:dark:text-black',
      success:
        'hover:bg-emerald-600 hover:text-white hover:text-white hover:dark:text-white hover:dark:border-emerald-600',
      danger:
        'hover:bg-red-600 hover:text-white hover:text-white hover:dark:text-white hover:dark:border-red-600',
      warning:
        'hover:bg-yellow-600 hover:text-white hover:text-white hover:dark:text-white hover:dark:border-yellow-600',
      info: 'hover:bg-peppermint hover:text-white hover:dark:text-white hover:dark:border-peppermint',
      transparent: 'transparent',
    },
  }

  if (!colors.bg[color]) {
    return color
  }

  const isOutlinedProcessed =
    isOutlined && ['white', 'whiteDark', 'lightDark'].indexOf(color) < 0

  const base = []
  base.push(colors.borders[color])
  base.push(colors.ring[color])

  if (isActive) {
    base.push(colors.active[color])
  } else {
    base.push(isOutlinedProcessed ? colors.text[color] : colors.bg[color])
  }

  if (hasHover) {
    base.push(
      isOutlinedProcessed ? colors.outlineHover[color] : colors.bgHover[color],
    )
  }

  return base
}

export const getQuoteStatusColor = status => {
  switch (status) {
    case QUOTE_STATUS.CONFIRMED:
      return 'success'
    case QUOTE_STATUS.PAYMENT_REQUIRED:
      return 'warning'
    case QUOTE_STATUS.DRAFT:
    case QUOTE_STATUS.PENDING:
    case QUOTE_STATUS.CHANGE_REQUESTED:
      return 'contrast'
  }
}

export const getTicketStatusColor = status => {
  switch (status) {
    case TICKET_STATUS.CLOSED:
    case TICKET_STATUS.RESOLVED:
      return 'success'
    case TICKET_STATUS.RESPONDED:
      return 'info'
    case TICKET_STATUS.OPEN:
    default:
      return 'contrast'
  }
}

export const getJobTypeColor = type => {
  switch (type) {
    case JOB_TYPE.MAILERS:
      return 'info'
    case JOB_TYPE.NEWSPAPERS:
    default:
      return 'contrast'
  }
}

export const TICKET_TYPE_COLOR = {
  DUMPING: 'danger',
  QUERY: 'info',
  DISPUTED: 'warning',
  EARLY: 'info',
  LATE: 'warning',
  NONDEL: 'lightDark',
  MULTIPLE: 'white',
  EMPTY: 'lightDark',
  NOCIRCS: 'white',
  ADDRESSED: 'lightDark',
  INTERFOLDING: 'light',
  AUDIT: 'warning',
  AUDITNEXT: 'warning',
  OTHER: 'info',
}
